import Navbar from "@/components/Navbar";
import { Link } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";

export default function Privacy() {
  return (
    <div className="min-h-screen bg-[#050505]">
      <Navbar />
      <article className="max-w-3xl mx-auto px-4 sm:px-6 py-10 text-white/80 leading-relaxed">
        <Link to="/" className="inline-flex items-center gap-2 text-white/60 hover:text-white text-sm mb-6">
          <ArrowLeft size={16} /> Volver al inicio
        </Link>

        <p className="text-sm uppercase tracking-widest text-[#FFB800] mb-3">Documento legal</p>
        <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tighter mb-2">Aviso de Privacidad</h1>
        <p className="text-white/40 text-sm mb-10">Última actualización: febrero de 2026</p>

        <Section title="1. Identidad y domicilio del responsable">
          <p>
            <strong className="text-white">Marketing de Inteligencia Artificial S. de R.L. de C.V.</strong> (en adelante, "la Empresa" o "Tu MusiKa"), con domicilio en Av. Américas 1545, Colonia Providencia, Guadalajara, Jalisco, México, es responsable del tratamiento de los datos personales que usted nos proporcione.
          </p>
          <p>
            El responsable designado para atender solicitudes en materia de protección de datos personales es <strong className="text-white">Ricardo Zermeño Mejía</strong>, contactable al WhatsApp <span className="font-mono text-white">+52 33 4280 2102</span>.
          </p>
        </Section>

        <Section title="2. Datos personales que recabamos">
          <p>Para brindarle nuestros servicios recabamos los siguientes datos personales:</p>
          <ul className="list-disc pl-6 space-y-1.5 mt-2">
            <li>Número de teléfono celular (utilizado como identificador de cuenta).</li>
            <li>Nombre o seudónimo artístico.</li>
            <li>Contraseña (almacenada en forma cifrada — nunca en texto plano).</li>
            <li>Historia personal, texto libre o cuestionario que usted proporciona como base para la creación de su canción.</li>
            <li>Fotografía que usted carga voluntariamente para la portada del álbum.</li>
            <li>Comprobante de pago (cuando elige transferencia bancaria), conservado para fines fiscales y de comprobación.</li>
            <li>Datos de la transacción de pago (monto, fecha, referencia). Los datos de su tarjeta NO son almacenados por nosotros; son procesados directamente por Stripe.</li>
          </ul>
        </Section>

        <Section title="3. Finalidades del tratamiento">
          <p>Los datos recabados se utilizan exclusivamente para las siguientes finalidades primarias:</p>
          <ul className="list-disc pl-6 space-y-1.5 mt-2">
            <li>Crear, autenticar y administrar su cuenta de usuario.</li>
            <li>Generar la letra y el audio de su canción mediante inteligencia artificial.</li>
            <li>Procesar el cobro de su paquete y emitir el comprobante correspondiente.</li>
            <li>Producir la portada del álbum con la fotografía que usted nos proporcione.</li>
            <li>Entregar el archivo musical final con metadatos.</li>
            <li>Atender solicitudes de soporte, aclaración o ejercicio de derechos ARCO.</li>
          </ul>
        </Section>

        <Section title="4. Transferencias de datos">
          <p>
            Sus datos pueden ser compartidos exclusivamente con los siguientes terceros, en lo estrictamente necesario para prestar el servicio:
          </p>
          <ul className="list-disc pl-6 space-y-1.5 mt-2">
            <li><strong className="text-white">Anthropic, PBC</strong> — proveedor del modelo de inteligencia artificial que redacta las letras. Únicamente se le envía la historia y los parámetros de la canción, sin ningún dato identificable de su persona.</li>
            <li><strong className="text-white">Proveedor de generación de audio musical</strong> — para producir el archivo MP3 a partir de la letra aprobada.</li>
            <li><strong className="text-white">Stripe, Inc.</strong> — para procesar pagos con tarjeta. Stripe es responsable de los datos de su tarjeta bajo sus propias políticas.</li>
            <li><strong className="text-white">BBVA México</strong> — únicamente cuando elige pagar por transferencia bancaria al beneficiario Ricardo Zermeño Mejía.</li>
          </ul>
          <p className="mt-3">No transferimos ni vendemos sus datos personales para fines de mercadotecnia de terceros.</p>
        </Section>

        <Section title="5. Derechos ARCO">
          <p>
            En todo momento usted tiene derecho a <strong className="text-white">Acceder</strong>, <strong className="text-white">Rectificar</strong>, <strong className="text-white">Cancelar</strong> u <strong className="text-white">Oponerse</strong> al tratamiento de sus datos personales (derechos ARCO), así como a revocar el consentimiento que nos haya otorgado.
          </p>
          <p className="mt-3">
            Para ejercer estos derechos, envíe su solicitud por WhatsApp al <span className="font-mono text-white">+52 33 4280 2102</span> indicando su nombre completo, número de teléfono registrado y el derecho que desea ejercer. Daremos respuesta en un plazo máximo de <strong className="text-white">20 días hábiles</strong> conforme a lo establecido en la Ley Federal de Protección de Datos Personales en Posesión de los Particulares (LFPDPPP).
          </p>
        </Section>

        <Section title="6. Uso de cookies y tecnologías similares">
          <p>
            Utilizamos almacenamiento local (localStorage) del navegador para mantener su sesión iniciada. No usamos cookies de rastreo de terceros con fines publicitarios.
          </p>
        </Section>

        <Section title="7. Seguridad">
          <p>
            Sus contraseñas se almacenan cifradas con algoritmo bcrypt. Las imágenes y archivos viajan por conexión HTTPS. Realizamos respaldos periódicos y limitamos el acceso a los datos al personal estrictamente necesario.
          </p>
        </Section>

        <Section title="8. Cambios al aviso de privacidad">
          <p>
            Nos reservamos el derecho de modificar este aviso. Cualquier cambio será publicado en esta misma URL con la fecha de actualización al inicio del documento. Le recomendamos revisarlo periódicamente.
          </p>
        </Section>

        <Section title="9. Aceptación">
          <p>
            Al utilizar Tu MusiKa, usted manifiesta haber leído y aceptado este Aviso de Privacidad y otorga su consentimiento expreso para el tratamiento de sus datos personales conforme a lo aquí establecido.
          </p>
        </Section>

        <div className="mt-10 pt-6 border-t border-white/10 text-sm text-white/40">
          <p>Marketing de Inteligencia Artificial S. de R.L. de C.V. · Guadalajara, Jalisco, México.</p>
        </div>
      </article>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <section className="mb-8">
      <h2 className="font-display text-xl sm:text-2xl font-bold text-white mb-3">{title}</h2>
      <div className="space-y-2">{children}</div>
    </section>
  );
}
